import TodoUpdateContainer from "../containers/TodoUpdateContainer";

const UpdatePage = () => {
  return <TodoUpdateContainer />;
};

export default UpdatePage;
